import React from 'react';

import { BackArrow } from 'components/navigation/back-arrow';
import { ClickEventComponentNames, logButtonClick } from 'state/amplitude';

import { ProductDetailBackArrowContainer } from './styled';
import { IProductDetailBackArrow } from './types';

export const ProductDetailBackArrow: React.FC<IProductDetailBackArrow> = ({
  onPress,
  eventAttributes = {},
  backNavigationLabel = '',
}) => {
  const handlePress = () => {
    logButtonClick({
      attributes: {
        ...eventAttributes,
        name: eventAttributes?.name ?? '',
        component: ClickEventComponentNames.PRODUCT_DETAIL_BACK_NAVIGATION,
      },
    });

    onPress();
  };

  return (
    <ProductDetailBackArrowContainer>
      <BackArrow onPress={handlePress} accessibilityLabel={backNavigationLabel} />
    </ProductDetailBackArrowContainer>
  );
};
